import PartnerPageTable from "./PartnerPageTable";
export default function PartnerMessagesPage() { return <PartnerPageTable title="Նամակագրություն" subtitle="Կապ հաստատեք PayWays-ի թիմի հետ" rows={[]} />; }
